import { useAuthData } from '@dev-agents/auth-context';
import { type ReactNode, useEffect, useState } from 'react';
import { IntlProvider } from 'react-intl';

import { getMessagesForLocale } from './utils';

export const DevAgentIntlProvider = ({ children }: { children: ReactNode }) => {
	const [messages, setMessages] = useState<undefined | Record<string, string>>(undefined);
	const {
		user: { locale },
	} = useAuthData();

	useEffect(() => {
		const loadMessages = async () => {
			try {
				const translatedMessages: Record<string, string> | undefined = await getMessagesForLocale(
					(locale ?? 'en-us').toLowerCase(),
				);

				setMessages(translatedMessages);
			} catch (e) {
				console.error(`Failed to load messages for locale ${locale}. Falling back to default:`, e);
				setMessages(undefined);
			}
		};

		loadMessages();
	}, [locale]);

	return (
		<IntlProvider
			locale={locale ?? 'en-US'}
			messages={messages || undefined}
			onError={(err) => {
				// Do not spam local devloop with missing translation errors
				//
				// See: https://github.com/formatjs/formatjs/issues/465#issuecomment-643887472
				// Note the default error handler: https://github.com/formatjs/formatjs/blob/d0b80fd9a814d1427b73577aebb7ccdb80b9ae94/packages/intl/src/utils.ts#L43
				if (process?.env?.NODE_ENV !== 'production' && err?.code !== 'MISSING_TRANSLATION') {
					// eslint-disable-next-line no-console
					console.error(err);
				}
			}}
		>
			{children}
		</IntlProvider>
	);
};
